<template>
  <div>
    <b-row>
      <b-col>
        <h3 class="mb-4">{{ this.$t("Two-Factor Authentication (2FA)") }}</h3>
        <div v-b-tooltip.hover :title="tooltipTitle" class="d-inline-block">
          <b-button
            v-b-modal.confirmation
            variant="outline-secondary"
            :disabled="!isButtonEnabled"
            >{{ this.$t("Reset 2FA for this admin") }}</b-button
          >
        </div>
      </b-col>
    </b-row>
    <t-confirmation @confirm="onConfirm">
      <div class="text-center">
        Reset disables 2FA for this admin. If 2FA is enforced, setup is required
        on next login.
      </div>
    </t-confirmation>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import TConfirmation from "@/modals/TReset2FAConfirmation";

export default {
  components: { TConfirmation },
  props: {
    id: {
      type: Number,
      required: true,
    },
    isTwoFAEnabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      fetching: false,
    };
  },
  computed: {
    ...mapGetters("authentication", ["role"]),
    hasPermission() {
      return Boolean(this.role === 1 || this.role === 3);
    },
    isButtonEnabled() {
      return this.hasPermission && this.isTwoFAEnabled;
    },
    tooltipTitle() {
      if (!this.isTwoFAEnabled) {
        return "2FA not setup";
      }
      if (!this.hasPermission) {
        return "You don't have permission to reset";
      }
      return undefined;
    },
  },
  methods: {
    ...mapActions("twoFactor", ["reset2FA"]),
    ...mapActions("toast", ["displayToast"]),

    async onConfirm() {
      this.fetching = true;
      try {
        await this.reset2FA(this.id);

        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Updated"),
          duration: 2000,
          variant: "success",
        });

        this.$emit("success");
      } finally {
        this.fetching = false;
      }
    },
  },
};
</script>
